<template>
	<section>
		<!--Toolbar -->
		<el-col :span="24" class="toolbar" style="font-size:14px" v-loading="dataLoading">
			<el-form :inline="true" label-width="140px" >        
        Booking *:
          <el-input size='small' style='width:100px' v-model="booking" placeholder="ID like '1234567'"></el-input>
        Departure :
          <el-date-picker size='small' style='width:135px' v-model="departure" type="date" placeholder="Departure date"
                    format="yyyy-MM-dd" value-format="yyyy-MM-dd"/>
        Flight :  <el-input size='small' style='width:100px' v-model="flightnum" placeholder='or1234'></el-input>
        Traject :
          <el-input size='small' style='width:120px' v-model="traject" placeholder="Flight info from/to: AMS-MAD"></el-input>
				  <!--
          <el-select size='small' style='width:150px' v-model="traject" Placeholder='Select Traject'>
          <el-option v-for="item in trajcodes" 
      		           :key='item' 
			 	             :label="item" 
			  	  				 :value='item'></el-option>
  		    </el-select>
          -->
          <el-checkbox size='small' v-model='allVersions'> AllVersions</el-checkbox>
					<el-button type="primary" icon='el-icon-search' size='small' style='float:right' v-on:click="startCheck">Check Status</el-button>
        <br>
      </el-form>
    </el-col>


		<el-col v-if="result!=''" :span="24"style="margin:10px 0 10px 0">
    Results:
	  </el-col>
    <el-col v-if="result!=''" :span="24" v-loading="dataLoading" >
        <el-input type='textarea' rows='20' v-model='result' style='line-height: 1.5em'>
        </el-input>
		</el-col>
		
</section>
</template>

<script>
  import settings from '../../common/AppSettings';
 	import util     from '../../common/AppUtil';
  import text     from '../../common/AppText';
  import api      from '../../api/dbc/dbccheck';

	export default {
		data() {
			return {
        QID         : util.Initialize(this.$router,"DBCC"),
        util        : util,
        stack       : {},
			  lang        : text.data,
        codes       : util.codes,

        editTitle   : "",
				editMode    : "",
				APICode     : "DbcCheck",
				mainFunc    : "DbcCheck",
				mainSubject : "file",
        mainKey     : "date",
				mainKeyDesc : "date",
        content: [],

        //trajcodes   : ["Outgoing","Return"],

        //78538553	Y	O	12/04/2022	12/04/2022 09:33	12/04/2022 09:33	1	03/03/2023	TB	3131	OST	03/03/2023 05:00	SSH	03/03/2023 10:25

        traject: "RTM-HRG",
        booking: "82208232",
        departure: "2023-03-05",
        flightnum: "OR3423",
        allVersions: false,
        result: "",
        dbcdescs: {},
				dataLoading: false,

      }
		},
		
		methods: {
 	  	closeForm: function () {
         this.selectorVisible = false;
	  	   //this.$router.push({name: 'Employees',params: this.stack});
    	},

		  startCheck: function() {
        let parg = {};

        this.result = "";
        this.desc = {};
        parg.Params = {};
        parg.Params.booking = this.booking;
        parg.Params.departure = this.departure;
        parg.Params.flightnum = this.flightnum;
        parg.Params.traject = this.traject;
        parg.Params.allVersions = this.allVersions;

        this.dataLoading = true;
        api.execute('checkbooking',parg).then((res) => {		
          var d = res.data;
            this.result = d.payload.dbccheck;
            this.dbcdescs = d.payload.dbcdescs;
            this.dataLoading = false;
          })
        .catch((error) => {
          util.serverError(this);
        });
      
      },
			
		},

		mounted() {
      
      window.addEventListener("popstate", (event) => {
        this.closeForm();
      });

      if (this.$route.params) {
        this.stack = this.$route.params;
      }      
		}
	}

</script>

<style>
  textarea{line-height: 1.5em}

</style>


// WEBPACK FOOTER //
// dbccheck.vue?0c4d58dc